import React, { useState } from 'react';
import { ArrowLeft } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { LocationCapture } from '../components/roadside/LocationCapture';
import { ServiceSelection } from '../components/roadside/ServiceSelection';
import { VehicleInfo } from '../components/roadside/VehicleInfo';
import { DisclaimerConfirm } from '../components/roadside/DisclaimerConfirm';
import { RequestTracking } from '../components/roadside/RequestTracking';
import { LanguageSelector } from '../components/LanguageSelector';
import { Button } from '../components/ui/button';

export const RoadsidePage = () => {
  const navigate = useNavigate();
  const [step, setStep] = useState(1);
  const [requestData, setRequestData] = useState({});
  const [requestNumber, setRequestNumber] = useState('');

  const handleLocationNext = (location) => {
    setRequestData({ ...requestData, location });
    setStep(2);
  };

  const handleServiceNext = (serviceData) => {
    setRequestData({ ...requestData, ...serviceData });
    setStep(3);
  };

  const handleVehicleNext = (vehicleData) => {
    setRequestData({ ...requestData, ...vehicleData });
    setStep(4);
  };

  const handleConfirmNext = (response) => {
    setRequestNumber(response.request_number);
    setStep(5);
  };

  const handleBack = () => {
    setStep(step - 1);
  };

  // Only show header when not on tracking page
  const showHeader = step !== 5;

  return (
    <div className="min-h-screen bg-gradient-to-br from-orange-50 via-white to-red-50">
      {showHeader && (
        <div className="fixed top-0 left-0 right-0 z-50 bg-white/95 backdrop-blur-sm shadow-md">
          <div className="max-w-7xl mx-auto px-4 py-3 flex justify-between items-center">
            <Button
              variant="ghost"
              onClick={() => navigate('/')}
              className="gap-2"
            >
              <ArrowLeft className="h-4 w-4" />
              <span>Home</span>
            </Button>
            <LanguageSelector />
          </div>
        </div>
      )}
      <div className={showHeader ? 'pt-16' : ''}>
        {step === 1 && <LocationCapture onNext={handleLocationNext} />}
        {step === 2 && <ServiceSelection onNext={handleServiceNext} onBack={handleBack} />}
        {step === 3 && (
          <VehicleInfo 
            serviceType={requestData.service_type} 
            onNext={handleVehicleNext} 
            onBack={handleBack} 
          />
        )}
        {step === 4 && (
          <DisclaimerConfirm requestData={requestData} onNext={handleConfirmNext} onBack={handleBack} />
        )}
        {step === 5 && <RequestTracking requestNumber={requestNumber} />}
      </div>
    </div>
  );
};
